import {
  createValidator,
  privacyPolicy,
  termsAndConditions,
} from './validation';
  
const userProfileUpdateConsentFields = {
  privacyPolicy: [privacyPolicy],
  userProfileTermsAndConditions: [termsAndConditions],
};
  
const userProfileUpdateConsentValidator = createValidator(userProfileUpdateConsentFields);
  
const userProfileUpdateConsentValidation = values => {
  return userProfileUpdateConsentValidator(values);
};

export default userProfileUpdateConsentValidation;